// DS: C110
/** A plain columned, list of topic links for use with a dropdown/opener */
import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { PapiTopic } from '@wix/da-papi-types';
import { Section } from '@wix/da-a11y/pkg/components/headings/tagWrappers';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';
import { BiEventType } from '@wix/da-bi/pkg/constants';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';

import s from './AllTopicsMenu.scss';

export interface Props {
  allTopics: PapiTopic[];
  className?: string;
}

const AllTopicsMenu: React.FC<Props> = props => {
  const { t } = useTranslation();
  const { allTopics = [], className } = props;

  const allTopicsSorted = allTopics.slice(0);
  allTopicsSorted.sort((a, b) => a.name.localeCompare(b.name));

  const rootClasses = classnames(s['root'], className);
  return (
    <Section id="AllTopicsMenu" className={rootClasses} role="dialog">
      <BiLoggerContextProvider value={{ sectionname: 'topTopicViewAll' }}>
        <Heading className={s['title']}>{t('topicListPage.allTopics')}</Heading>
        <nav className={s['menu']}>
          {allTopicsSorted.map((topic, index) => (
            <BiLink
              key={topic.name}
              href={topic.url}
              className={s['link']}
              biData={{
                evid: BiEventType.ITEM_CLICK,
                typeid: topic.typeId,
                itemid: topic.itemId,
                rank: index,
              }}
            >
              {topic.name}
            </BiLink>
          ))}
        </nav>
      </BiLoggerContextProvider>
    </Section>
  );
};
AllTopicsMenu.displayName = 'AllTopicsMenuC110';
export default AllTopicsMenu;
